import React, { useState, useEffect } from "react";
import {
  TitleComponent,
  CardComponent,
  TableComponent,
  ButtonGenerateExcelAuditComponent,
  DinamicTableComponent,
  ButtonActionComponent,
  InputFileComponent,
  ButtonIconComponent,
  CellComponent,
  PortalComponent,
  ModalComponent,
  InputTextComponent,
  SelectComponent,
  SelectComponentMulti,
} from "../../../components/pages/index";
import { api, apiConfig } from "../../../util/api";
import { Switch } from "@headlessui/react";
import { useGetApiWs, useChangeDocTitle } from "../../../hooks/index";
import { getInfoUser } from "../../../util/auth";

const Prices = (props) => {
  useChangeDocTitle("Reportes | Auditoría | Precio Moda / Promedio");
  const urlCustomer = useGetApiWs("admin", "entity", "company-get");
  const urlCustonerInfo = useGetApiWs("admin", "entity", "customer-get");
  const urlChannel = useGetApiWs(
    "admin",
    "entity",
    "customer-category-channel-get"
  );
  const urlFilter = useGetApiWs("admin", "entity", "generate-report");

  const [customers, setCustomers] = useState([]);
  const [category, setCategory] = useState([]);

  const [attributes, setAttributes] = useState([]);
  const [cities, setCities] = useState([]);
  const [channels, setChannels] = useState([]);
  const [valores, setValores] = useState([{ value: "AB", label: "ABSOLUTOS" }]);
  const [defattributes, setDefAttributes] = useState([]);
  const [defcities, setDefCities] = useState([]);
  const [defchannels, setDefChannels] = useState([]);
  const [defMeasurements, setDefMeasurements] = useState([]);

  const [measurement, setMeasurement] = useState([]);
  const [variables, setVariables] = useState([
    { value: "MOD", label: "PRECIO MODA" },
    { value: "PRO", label: "PRECIO PROMEDIO" },
    { value: "SIMP", label: "PRECIO PROMEDIO SKU" },
  ]);

  const [lbCustomer, setLbCustomer] = useState(null);
  const [lbCategory, setLbCategory] = useState(null);
  const [lbAttributes, setLbAttributes] = useState(null);
  const [lbCities, setLbCities] = useState(null);
  const [lbChannels, setLbChannels] = useState(null);
  const [lbValores, setLbValores] = useState(null);
  const [lbMeasurement, setLbMeasurement] = useState(null);
  const [lbVariables, setLbVariables] = useState(null);

  const [customerIsLoading, setCustomerIsLoading] = useState(true);
  const [categoryIsLoading, setCategoryIsLoading] = useState(true);
  const [attributesIsLoading, setAttributesIsLoading] = useState(true);
  const [citiesIsLoading, setCitiesIsLoading] = useState(true);
  const [channelsIsDisabled, setChannelsIsDisabled] = useState(false);
  const [channelsIsLoading, setChannelsIsLoading] = useState(true);
  const [measurementLoading, setMeasurementIsLoading] = useState(true);

  const [Enabled, setEnabled] = useState(false);
  const [tbHeadings, setTbDataHeadings] = useState([]);
  const [tbData, setTbData] = useState([]);
  const [tbColumns, setTbColumns] = useState([]);
  const [tbPending, setTbPending] = useState(true);
  const [btnExports, setBtnExports] = useState(false);

  const [Disabled, setDisabled] = useState();
  const data = JSON.parse(getInfoUser());

  const wbname = "Prices";
  useEffect(() => {
    // Solo aplicar los filtros si el prop test es diferente de 3
    if (lbCustomer != null) {
      if (props.test !== 3 && lbCustomer.label === "ALICORP") {
        // console.log(lbCities, lbCategory, cities);
        if (
          lbCategory !== null &&
          lbCategory.label === "PREMEZCLAS INDUSTRIALES" &&
          lbCities.some(
            (val) => val.label === "IQUITOS" || val.label === "TACNA"
          )
        ) {
          setLbValores([{ value: "PO", label: "PORCENTAJES" }]);
        } else {
          setLbValores([]);
        }

        if (
          lbCategory !== null &&
          lbCategory.label === "PREMEZCLAS INDUSTRIALES" &&
          lbCities.some(
            (val) => val.label === "TACNA" || val.label === "IQUITOS"
          )
        ) {
          setLbValores([]);
        }
        if (
          lbCategory !== null &&
          lbCategory.label === "PREMEZCLAS INDUSTRIALES" &&
          lbCities.some((val) => val.label === "PUCALLPA")
        ) {
          setLbValores([{ value: "PO", label: "PORCENTAJES" }]);
        }
        if (lbCategory !== null && lbCategory.label === "LIMPIADORES") {
          setLbValores([{ value: "PO", label: "PORCENTAJES" }]);
        }
      }
    }
  }, [lbCustomer, lbCategory, lbCities, props.test]);

  const fetchCustomers = async () => {
    const customers = await api().post(
      urlCustomer,
      { company_type_code: "CM-CUST" },
      apiConfig()
    );
    var options = customers.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.company_id;
      rObj["label"] = obj.description;
      return rObj;
    });
    setCustomers(options);
    setCustomerIsLoading(false);
    if (data.code == "CM-CUST") {
      CustomerChange({ value: data.company_id, label: data.company_name });
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };
  const fetchAttributes = async (category_id, customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    ob["type_info"] = "attributes";
    if (props.test != null || props.test != undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const customers = await api().post(urlCustonerInfo, ob, apiConfig());
    var options = customers.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.feature_type_id;
      rObj["label"] = obj.feature_type_name;
      return rObj;
    });
    setAttributes(options);
    setAttributesIsLoading(false);
  };
  const fetchCities = async (category_id, customer_id, enabled) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    if (props.test) {
      ob["is_test"] = 1;
    } else {
      ob["is_test"] = 0;
    }

    if (enabled == true) {
      ob["type_info"] = "cities";
      const customers = await api().post(urlCustonerInfo, ob, apiConfig());
      var options = customers.data.response.map((obj) => {
        var rObj = {};
        rObj["value"] = obj.city_id;
        rObj["label"] = obj.name;
        return rObj;
      });
      setCities(options);
      setCitiesIsLoading(false);
    } else if (enabled == false) {
      ob["type_info"] = "zones";
      const customers = await api().post(urlCustonerInfo, ob, apiConfig());
      var options = customers.data.response.map((obj) => {
        var rObj = {};
        rObj["value"] = obj.city_id;
        rObj["label"] = obj.name;
        return rObj;
      });
      setCities(options);
      setCitiesIsLoading(false);
    }
  };
  const fetchChannels = async (category_id, customer_id) => {
    const channels = await api().post(
      urlChannel,
      { category_id: category_id, customer_id: customer_id },
      apiConfig()
    );
    var options = channels.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.channel_id;
      rObj["label"] = obj.name;
      return rObj;
    });
    setChannels(options);
    setChannelsIsLoading(false);
  };
  const fetchMeasurement = async (category_id, customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    ob["type_info"] = "measurements";
    if (props.test != null || props.test != undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const measurement = await api().post(urlCustonerInfo, ob, apiConfig());
    var options = measurement.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.measurement_id;
      rObj["label"] = obj.description;
      return rObj;
    });
    setMeasurement(options);
    setMeasurementIsLoading(false);
  };
  const fetchCategory = async (customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["study_id"] = 17;
    ob["type_info"] = "categories";
    if (props.test != null || props.test != undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
    if (cWorkOrders.status === 200 && cWorkOrders.data.status === "success") {
      var options = cWorkOrders.data.response.map((obj) => {
        var rObj = {};
        rObj["value"] = obj.category_id;
        rObj["label"] = obj.category_name;
        return rObj;
      });
      setCategory(options);
    }
    setCategoryIsLoading(false);
  };

  const CustomerChange = async (vals) => {
    setLbCustomer(vals);
    if (vals === null) {
      setCategory([]);
      setLbCategory(null);
    } else {
      setCategory([]);
      setLbCategory(null);
      fetchCategory(vals.value);
    }
  };

  const CategoryChange = async (vals) => {
    ClearForm();
    setLbCategory(vals);
    const enabled = true;

    if (vals != null) {
      fetchAttributes(vals.value, lbCustomer.value);
      fetchCities(vals.value, lbCustomer.value, enabled);
      fetchChannels(vals.value, lbCustomer.value);
      fetchMeasurement(vals.value, lbCustomer.value);
    }
  };

  const CityChange = async (vals) => {
    setLbCities(vals);

    const arrCities = vals.map((obj) => {
      return obj.label;
    });

    if (arrCities.includes("LIMA") & (arrCities.length === 1)) {
      setChannelsIsDisabled(false);
    } else {
      setDefChannels(channels);
      setLbChannels(channels);
      setChannelsIsDisabled(true);
    }

    if (arrCities.length === 0) {
      setChannelsIsDisabled(false);
    }
  };

  const MeasurementChange = async (vals) => {
    setLbMeasurement(vals);
  };

  const ValuesChange = async (vals) => {
    console.log("aaaxx", vals);

    const newVals = Array.isArray(vals) ? vals : [vals];
    setLbValores(newVals);
  };

  const VariablesChange = async (vals) => {
    setLbVariables(vals);
  };

  const Filter = () => {
    setBtnExports(false);
    fetchFilters(lbVariables);
  };

  const fetchFilters = async (valores) => {
    if (
      lbCategory != null &&
      lbChannels != null &&
      lbAttributes != null &&
      lbCities != null &&
      lbMeasurement != null &&
      valores != null
    ) {
      setTbPending(true);
      const ob = {};
      ob["type"] = "precio_promedio_y_moda";
      ob["customer_id"] = lbCustomer.value;
      ob["category_id"] = lbCategory.label + "|" + lbCategory.value + "|";

      const fea = lbAttributes.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });
      const feahead = lbAttributes.map((obj) => {
        return { value: obj.value, label: obj.label, title: obj.label };
      });

      const measurements = lbMeasurement.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });
      const chan = lbChannels.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });

      const arrValor = [];
      for (const a in lbMeasurement) {
        lbValores.map((obj) => {
          let addText = "";
          if (obj.value == "PO") {
            addText = " %";
          }
          arrValor.push({
            value:
              valores.value + "_" + obj.value + "-" + lbMeasurement[a].label,
            label:
              valores.value + "_" + obj.value + "-" + lbMeasurement[a].label,
            title: lbMeasurement[a].label + addText,
          });
        });
      }

      const headercolumn = [...feahead, ...arrValor];
      const cit = lbCities.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });

      const headTable = lbAttributes.map((obj) => {
        return obj.label;
      });
      setTbDataHeadings(headTable);
      //setTbDataHeadings(JSON.stringify(head));
      ob["features"] = fea.join(",");
      ob["cities"] = cit.join(",");
      ob["channels"] = chan.join(",");
      ob["measurement_id"] = measurements.join(",");
      ob["is_for_export"] = 0;
      if (props.test) {
        ob["is_test"] = props.test;
      } else {
        ob["is_test"] = 0;
      }
      const res = await api().post(urlFilter, ob, apiConfig());
      if (res.data.status === "success") {
        let colum = [];

        if (res.data.response.length > 0) {
          colum = headercolumn.map((obj) => {
            return {
              name: obj.title,
              selector: obj.label,
              sortable: false,
              wrap: true,
            };
          });
          setBtnExports(true);
          setTbColumns(colum);
          setTbData(res.data.response);
          setTbPending(false);
        } else {
          setBtnExports(false);
          setTbColumns([]);
          setTbData([]);
          setTbPending(false);
        }
      }
    } else {
      return null;
    }
  };

  const ClearForm = () => {
    setAttributes([]);
    setCities([]);
    setChannels([]);
    setMeasurement([]);

    setDefAttributes([]);
    setDefCities([]);
    setDefChannels([]);
    setDefMeasurements([]);

    setLbMeasurement([]);
    setLbAttributes([]);
    setLbCities([]);
    setLbChannels([]);

    setAttributesIsLoading(false);
    setCitiesIsLoading(false);
    setChannelsIsLoading(false);
    setChannelsIsDisabled(false);
    setMeasurementIsLoading(false);
    setBtnExports(false);
    setTbData([]);
    setTbPending(false);
  };

  useEffect(() => {
    fetchCustomers();
    setCategory([]);
    setLbCategory(null);
    setCategoryIsLoading(false);
    //setLbValores([{ value: "AB", label: "ABSOLUTOS" }]);
    ClearForm();
  }, []);

  const SwitchButton = (props) => {
    const onChange = (value) => {
      setEnabled(value);
      fetchCities(lbCategory.value, lbCustomer.value, Enabled);
    };
    return (
      <div className="flex">
        <h4 className="mr-1">{"Ciudades"}</h4>
        <Switch
          checked={Enabled}
          onChange={onChange}
          className={`${
            Enabled
              ? props.bg_active ?? "bg-gray-400"
              : props.bg_inactive ?? "bg-gray-400"
          } relative inline-flex h-4 w-10 items-center rounded-full`}
        >
          <span
            aria-hidden="true"
            className={`${Enabled ? "translate-x-5" : "translate-x-0"}
                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
        <h4 className="ml-1">{"Zonas de Lima"}</h4>
      </div>
    );
  };

  return (
    <div>
      <TitleComponent title="Auditoría | Reporte | Precio Moda / Promedio" />
      <div className="pt-3">
        <CardComponent header={null} footer={null}>
          <div className="bg-white p-2">
            <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4">
              <SelectComponent
                onChange={CustomerChange}
                options={customers}
                value={lbCustomer}
                isLoading={customerIsLoading}
                label="Clientes"
                isDisabled={Disabled}
              />
              <SelectComponent
                onChange={CategoryChange}
                options={category}
                value={lbCategory}
                isLoading={categoryIsLoading}
                label="Categoría"
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  setLbAttributes(vals);
                }}
                defaultValue={defattributes}
                options={attributes}
                value={lbAttributes}
                isLoading={attributesIsLoading}
                label="Atributos"
              />
              <SelectComponentMulti
                onChange={CityChange}
                defaultValue={defcities}
                options={cities}
                value={lbCities}
                isLoading={citiesIsLoading}
                label={<SwitchButton name="Ciudad" name2="Zonas" />}
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  setLbChannels(vals);
                }}
                defaultValue={defchannels}
                options={channels}
                value={lbChannels}
                isLoading={channelsIsLoading}
                isDisabled={channelsIsDisabled}
                label="Canales"
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  MeasurementChange(vals);
                }}
                defaultValue={defMeasurements}
                value={lbMeasurement}
                options={measurement}
                isLoading={measurementLoading}
                label="Medición"
              />
              <SelectComponent
                onChange={ValuesChange}
                options={valores}
                value={lbValores}
                label="Valores"
                isDisabled={
                  (lbCategory !== null &&
                    lbCategory.label === "PREMEZCLAS INDUSTRIALES" &&
                    lbCities.some(
                      (val) =>
                        val.label === "IQUITOS" ||
                        val.label === "TACNA" ||
                        val.label === "CHIMBOTE" ||
                        val.label === "PUCALLPA"
                    )) ||
                  (props.test !== 3 &&
                    lbCategory !== null &&
                    lbCategory.label === "LIMPIADORES")
                }
              />
              <SelectComponent
                onChange={VariablesChange}
                options={variables}
                value={lbVariables}
                isLoading={false}
                label="Variables"
              />
            </div>
            <div className="bg-white p-2 justify-items-end grid">
              <div className="space-x-4">
                <ButtonActionComponent
                  name="GENERAR REPORTE"
                  onClick={Filter}
                />
                {btnExports ? (
                  <ButtonGenerateExcelAuditComponent
                    name="EXPORTAR EXCEL"
                    onClick={props.createDataExcel}
                    tbColumns={tbColumns}
                    tbData={tbData}
                    lbCustomer={lbCustomer}
                    lbMeasurement={lbMeasurement}
                    lbCategory={lbCategory}
                    lbCities={lbCities}
                    lbAttributes={lbAttributes}
                    lbChannels={lbChannels}
                    lbValores={lbValores}
                    lbVariables={lbVariables}
                    wbname={wbname}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </CardComponent>
      </div>

      <div className="pt-3">
        <CardComponent
          header={<h4 className="">Precio Moda / Promedio</h4>}
          footer={null}
        >
          <div className="bg-white">
            <div></div>
            <TableComponent
              keyField="work_order_id"
              columns={tbColumns}
              headItem={tbHeadings}
              data={tbData}
              pending={tbPending}
              highlightOnHover={true}
            />
          </div>
        </CardComponent>
      </div>
    </div>
  );
};

export default Prices;
